export default {"src":"/_next/static/image/components/ui/Icon/icons/check-mark.62a74456d7452bfde4f4bf95db5d28cd.svg","height":6,"width":8};